import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { api } from "@/lib/apiClient";

const localDate = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

// Counts a "night rested with Xcelio" (5+ min of a Sleep track) and keeps the screen awake while it plays.
export function useSleepNight(active, instId) {
  const secs = useRef(0);
  const reported = useRef(false);
  useEffect(() => {
    if (!active) return;
    let lock = null;
    const grab = async () => { try { lock = await navigator.wakeLock?.request("screen"); } catch {} };
    grab();
    const onVis = () => { if (document.visibilityState === "visible") grab(); };
    document.addEventListener("visibilitychange", onVis);
    const t = setInterval(() => {
      secs.current += 5;
      if (secs.current >= 300 && !reported.current) {
        reported.current = true;
        api.post("/sleep/session", { installation_id: instId, seconds: secs.current, local_hour: new Date().getHours(), local_date: localDate() }).catch(() => {});
      }
    }, 5000);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVis); try { lock?.release(); } catch {} };
  }, [active, instId]);
}

export default function SleepDim({ active }) {
  const [dim, setDim] = useState(false);
  useEffect(() => {
    if (!active) { setDim(false); return; }
    let t = setTimeout(() => setDim(true), 10000);
    const wake = () => { setDim(false); clearTimeout(t); t = setTimeout(() => setDim(true), 10000); };
    window.addEventListener("pointerdown", wake);
    return () => { clearTimeout(t); window.removeEventListener("pointerdown", wake); };
  }, [active]);
  return (
    <AnimatePresence>
      {dim && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 2.5 }}
          className="fixed inset-0 z-50 bg-black flex items-center justify-center cursor-pointer" data-testid="sleep-dim">
          <motion.div className="w-48 h-48 rounded-full"
            style={{ background: "radial-gradient(circle, rgba(140,160,230,0.28) 0%, rgba(90,110,190,0.08) 45%, transparent 70%)" }}
            animate={{ scale: [0.8, 1.15, 0.8], opacity: [0.35, 0.8, 0.35] }}
            transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }} data-testid="sleep-glow" />
          <p className="absolute bottom-10 text-[11px] tracking-[0.25em] uppercase text-white/15">Tap to show controls</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
